export const DURATION_TYPES = [
  { label: "Dias", value: "Dias" },
  { label: "Meses", value: "Meses" },
  { label: "Anos", value: "Anos" },
]
